import React from "react";
import { Skeleton } from "@mui/material";

const LoadingComponent = () => {
  return (
    <div className="p-4 space-y-8 bg-white">
      <div className="space-y-8">
        {[...Array(6)].map((_, index) => (
          <Skeleton
            key={index}
            variant="rounded"
            width="100%"
            height={200}
            animation="wave"
          />
        ))}
      </div>
    </div>
  );
};

export default LoadingComponent;
